module.exports = __webpack_public_path__ + "img/platform.98ea918.png";